export const buySteps = [
  {text: 'Carrito', value: "1", path: '/compra/carrito'},
  {text: 'Datos Usuario', value: "2", path: '/compra/inicio-sesion-pedido'},
  {text: 'Envío y Facturación', value: "3", path: '/compra/datos-adicionales'},
  {text: 'Confirmar Pedido', value: "4", path: '/compra/datos-adicionales'},
]
